export default "__VITE_ASSET__BrfXdjgU__"